const dishTypeNotesFormInitialValues = values => ({
  notes: values.notes,
})

export default dishTypeNotesFormInitialValues
